import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-college-info-details-create",
  templateUrl: "./college-info-details-create.component.html",
  styleUrls: ["./college-info-details-create.component.scss"],
})
export class CollegeInfoDetailsCreateComponent implements OnInit {
  public tinyConfig = {
    base_url: '/assets/tinymce',
    suffix: '.min',
    height: 400,
    menubar: true,
    plugins: 'code table link image lists',
    apiKey: '',
    toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | table | link image | code',
  };
  @Input() record: any;          // ✅ data for edit
  @Input() collegeId: string;    // ✅ college id from parent
  @Output() formSaved = new EventEmitter<void>();  // ✅ notify parent
  @Output() cancel = new EventEmitter<void>();     // ✅ cancel event

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  isShown: boolean = false;
  typeofcolleges = null;
  streams = null;
  courses = null;
  degrees = null;
  universitys = null;
  colleges = [];
  branches = null;


  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) { }

  public reg = "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  ngOnInit() {
    let role = localStorage.getItem("userRole");
    let user = localStorage.getItem("userId");

    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(`${environment.apiUrl}/collegeinformations/${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            console.log(data);

            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            // console.log(data);
            if (data != null) {
              this.action = "Update";
              this.Form.patchValue({
                _id: data._id,
                collegeinfoshort: data.collegeinfoshort,
                image: data.image,
                college: data.college,
                streamsid: data.streams,
                typeofcollegeid: data.typeofcollege,
                universityid: data.university,
                degreeid: data.degree,
                courseid: data.course,
                branchid: data.branch,

              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
      this.http
        .get<any>(`${environment.apiUrl}/collegeinformations/bycollegeId?college=${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            console.log(data);
            console.log(data.results);
            console.log(data.results[0].college);

            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data != "") {

              this.action = "Update";


              this.Form.patchValue({
                _id: data._id,
                college: data.results[0].college,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    // Add this with your other HTTP calls
    this.http
      .get<any>(`${environment.apiUrl}/college/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.colleges = data.results || data; // Store colleges list
        },
        (err: HttpErrorResponse) => {
          console.error("Error loading colleges:", err);
        }
      );


    this.Form = this.formBuilder.group({
      collegeinfoshort: ["", Validators.required],
      image: ["", [Validators.required]],
      _id: [""],
      college: ["", Validators.required],
      streamsid: ["", Validators.required],
      typeofcollegeid: ["", Validators.required],
      universityid: ["", Validators.required],
      degreeid: ["", Validators.required],
      courseid: ["", Validators.required],
      branchid: ["", Validators.required],

    });
    if (this.record) {
      this.action = "Update";
      this.Form.patchValue(this.record);
    } else {
      this.action = "Submit";
      this.Form.patchValue({ college: this.collegeId });
    }
    this.http
      .get<any>(`${environment.apiUrl}/typeofcollege/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.typeofcolleges = data.results;
          // console.log(data.results[0].name);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    this.http
      .get<any>(`${environment.apiUrl}/streams/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.streams = data.results;
          // console.log(data.results[0].name);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    this.http
      .get<any>(`${environment.apiUrl}/university/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.universitys = data.results;
          // console.log(data.results[0].name);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    this.http
      .get<any>(`${environment.apiUrl}/course/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.courses = data.results;
          // console.log(data.results);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    this.http
      .get<any>(`${environment.apiUrl}/degree/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.degrees = data.results;
          // console.log(data.results[0].name);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

    this.http
      .get<any>(`${environment.apiUrl}/branch/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          console.log(data);
          console.log(data.results);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.branches = data.results;
          // console.log(data.results[0].name);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

  }



  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        collegeinfoshort: this.Form.value.collegeinfoshort,
        image: this.Form.value.image,
        college: this.Form.value.college,
        'typeofcollege': this.Form.value.typeofcollegeid,
        'streams': this.Form.value.streamsid,
        'university': this.Form.value.universityid,
        'course': this.Form.value.courseid,
        'degree': this.Form.value.degreeid,
        'branch': this.Form.value.branchid,
      };
      console.log(data);

      this.http
        .post<any>(`${environment.apiUrl}/collegeinformations/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(


          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-info-details-list");
              this.formSaved.emit();   // ✅ emit on success
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    } else {
      let data = {
        collegeinfoshort: this.Form.value.collegeinfoshort,
        image: this.Form.value.image,
        college: this.Form.value.college,
        'typeofcollege': this.Form.value.typeofcollegeid,
        'streams': this.Form.value.streamsid,
        'university': this.Form.value.universityid,
        'course': this.Form.value.courseid,
        'degree': this.Form.value.degreeid,
        'branch': this.Form.value.branchid,
      };
      console.log(data);
      let id = this.Form.value._id;
      console.log(id);

      this.http
        .patch<any>(`${environment.apiUrl}/collegeinformations/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.router.navigateByUrl("/college-details/college-info-details-list");
              this.formSaved.emit();   // ✅ emit on success
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
  onCancel() {
    if (this.cancel.observers.length > 0) {
      // Case 1: Modal
      this.cancel.emit();
    } else {
      // Case 2: Standalone
      this.router.navigateByUrl("/college-details/college-info-details-list");
    }
  }

}
